@if (!isAbridged()){
  <app-incident-search
  [searchTerm]="searchTerm()"
  [dateRange]="dateRange()"
  (searchTermChange)="onSearchTermChange($event)"
  (dateRangeChange)="onDateRangeChange($event)"
  (clearFilters)="onClearFilters()">
</app-incident-search>
}
@if (callcentreOperators.length > 0) {
  <div class="callcentre-operator-filter">
    <span class="callcentre-operator-filter-label">Handled by:</span>
    <div class="callcentre-operator-filter-options">
      @for (operator of callcentreOperators; track operator.userId) {
        <button
          nz-button
          nzSize="small"
          [class.whatsapp-only-operator]="operator.isWhatsappOnlyNotificationRecipient"
          [nzType]="isCallcentreOperatorSelected(operator.userId) ? 'primary' : 'default'"
          [attr.aria-label]="operator.isWhatsappOnlyNotificationRecipient ? getCallcentreOperatorName(operator) + ' (WhatsApp-only recipient)' : getCallcentreOperatorName(operator)"
          [attr.title]="operator.isWhatsappOnlyNotificationRecipient ? 'WhatsApp-only notification recipient' : null"
          (click)="toggleCallcentreOperator(operator.userId)">
          @if (operator.isWhatsappOnlyNotificationRecipient) {
            <nz-icon nzType="whats-app" nzTheme="outline" />
          }
          {{ getCallcentreOperatorName(operator) }}
        </button>
      }
    </div>
    <label
      nz-checkbox
      [ngModel]="displayAsGroup()"
      (ngModelChange)="setDisplayAsGroup($event)"
      class="callcentre-operator-group-toggle">
      Display As Group.
    </label>
    @if (selectedCallcentreOperatorIds().size > 0) {
      <button
        nz-button
        nzType="link"
        nzSize="small"
        class="callcentre-operator-filter-clear"
        (click)="clearCallcentreOperatorFilter()">
        Clear
      </button>
    }
  </div>
}
@if (!isAbridged()) {
  <nz-collapse style="margin-bottom: 16px;" >
  <nz-collapse-panel nzHeader="Breakdowns by Status" [nzShowArrow]="true">
  <nz-card nzSize="small">
    <div style="display: flex; flex-wrap: wrap; justify-content: space-around;">
      @for (item of statusCounts(); track item.status) {
        <div style="border: 1px solid #d9d9d9; padding: 12px 10px; text-align: center; min-width: 120px;">
          <nz-statistic
            [nzValue]="item.count"
            [nzTitle]="item.status"
            [nzValueStyle]="{ color: '#3f8600' }">
          </nz-statistic>
        </div>
      }
    </div>
  </nz-card>
  </nz-collapse-panel>
</nz-collapse>
}


<nz-table [nzData]="tableRows()" nzTableLayout="fixed" nzSize="small" [nzLoading]="isLoading()" [nzScroll]="{ y: '70vh' }" [nzFrontPagination]="false">
  <thead>
    <tr>
      @for (col of columns(); track col.key) {
      <th [nzWidth]="col.width || 'auto'">{{ col.title }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of tableRows(); track row.key) {
      @if (row.kind === 'group') {
        <tr class="callcentre-operator-group-header" [class.whatsapp-only-operator-group]="row.isWhatsappOnlyNotificationRecipient">
          <td [attr.colspan]="columns().length">
            @if (row.isWhatsappOnlyNotificationRecipient) {
              <nz-icon nzType="whats-app" nzTheme="outline" />
            }
            <span class="callcentre-operator-group-title">Handled by {{ row.name }}</span>
            <span class="callcentre-operator-group-count">{{ row.incidentCount }} {{ row.incidentCount === 1 ? 'breakdown' : 'breakdowns' }}</span>
          </td>
        </tr>
      } @else {
        @let data = row.incident;
      <!-- <tr [ngClass]="{ 'tech-late': isTechLate(data) }" [nz-tooltip]="isTechLate(data) ? 'Breakdown running late' : '' "> -->
      <tr [ngClass]="{ 'selected-row': data.incidentId === selectedIncident()?.incidentId }">
        @for (col of columns(); track col.key) {
        <td [style.background-color]="getActionColumnBackground(col.key, data)">
          @switch (col.key) {
          @case ('incidentNo') {
            <div style="display: flex; justify-content: space-between; align-items: flex-start;">
              <div>
                @if (data.clientWhatsappGroupLink) {
                    <a (click)="openWaGroupOpener(data, data.clientWhatsappGroupLink, true)" style="cursor: pointer;">
                      <strong style="color: black; margin-right: 8px;">{{ data.clientName}}</strong> <br />
                      @if (!data.incidentActions?.dtWAMessageCopiedFleet) {
                        <nz-icon nzType="warning" nzTheme="fill" [ngStyle]="{ 'font-size': '16px', 'color': '#faad14' }" nz-tooltip nzTooltipTitle="Fleet has not been contacted yet"></nz-icon>
                      }
                      <nz-icon nzType="whats-app" nzTheme="outline" [ngStyle]="{ 'font-size': '18px', 'color': '#25D366' }"></nz-icon>
                      {{data.clientWhatsappGroupName ? data.clientWhatsappGroupName : ''}}
                    </a>
                    <div><small><b>{{data.transporterName}}</b></small></div>
                } @else {
                  <strong>{{ data.clientName }} </strong>
                  <div><small><b>{{data.transporterName}}</b></small></div>
                }
                <!-- Callcentre2Callcentre -->
                @if (authService.user && getOtherMainCallcentre(data)) {
                  @let otherCC = getOtherMainCallcentre(data);
                  
                  @if (otherCC && otherCC.whatsappGroupLink){
                    <a (click)="openWaGroupOpener(data, otherCC.whatsappGroupLink)" style="cursor: pointer;">
                      <small>Via: {{ otherCC?.clientName }}</small>
                      @if (!data.incidentActions?.dtWAMessageCopiedFleet) {
                        <nz-icon nzType="warning" nzTheme="fill" [ngStyle]="{ 'font-size': '16px', 'color': '#faad14' }" nz-tooltip nzTooltipTitle="Fleet has not been contacted yet"></nz-icon>
                      }
                      <nz-icon nzType="whats-app" nzTheme="outline" [ngStyle]="{ 'font-size': '18px', 'color': '#25D366' }"></nz-icon>
                      <small>{{otherCC.whatsappGroupName ? otherCC.whatsappGroupName : ''}}</small>
                    </a>
                  }
                  @else {
                    <small>Via: {{ otherCC?.clientName }}</small>
                  }
                }
              </div>
              <a (click)="openFleetTrackingLink(data.incidentId)" style="cursor: pointer; margin-left: 6px; flex-shrink: 0;" nz-tooltip nzTooltipTitle="Open fleet tracking page">
                <nz-icon nzType="link" nzTheme="outline" [ngStyle]="{ 'font-size': '16px', 'color': '#1890ff' }"></nz-icon>
              </a>
            </div>
          }
          @case ('dt') {
            <small>{{ data.dtLogged + 'Z' | date:'MMM d, y h:mm a' }}</small><br />
            <span nz-tooltip [nzTooltipTitle]="data.location.description">
              <small>{{ data.location.descriptionShort }}</small>
            </span>
          }
          <!-- @case ('fleet') {
          <small>{{ data.clientName }}</small>
          } -->
          @case ('vehicleAndDriver') {
          <div style="font-weight: bold;">{{ data.fleetVehicle.registrationNumber }}</div>
          <!-- <div>{{ data.driver.name }}</div>
          <small style="color: #8c8c8c;">{{ data.driver.phoneNumber }}</small> -->
          <div class="incident-number-line">
          <a (click)="onClickViewIncident(data)" style="text-align: left;" nz-row>
                <strong>#{{ data.incidentNumber }}</strong>
                @if (data.orderNumber) {/ <span style="font-weight: bold;">{{data.orderNumber}}</span><br />}
              </a>
          @if (hasChatEscalation(data.incidentId)) {
            <button nz-button nzType="link" nzSize="small" class="incident-unread-chat escalated"
              [attr.aria-label]="'Incident ' + data.incidentNumber + ': escalated chat'" nz-tooltip
              nzTooltipTitle="Service Provider escalated a message" (click)="onClickViewIncident(data)">
              <nz-icon nzType="exclamation-circle" />
            </button>
          } @else {
          @if (unreadChatCount(data.incidentId); as unread) {
            <button nz-button nzType="link" nzSize="small" class="incident-unread-chat"
              [attr.aria-label]="'Incident ' + data.incidentNumber + ': ' + unread + ' unread chat ' + (unread === 1 ? 'message' : 'messages')"
              nz-tooltip nzTooltipTitle="Open incident to view unread chat" (click)="onClickViewIncident(data)">
              <nz-icon nzType="message" />
            </button>
          }
          }
          </div>
          }
          @case ('status') {
            @let state = getIncidentCurrentState(data);
            <div class="next-status-col">
              @if (state === null) {
                <span class="state-label state-completed">
                  <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Completed
                </span>
              } @else {
                <div [class]="'state-label ' + (state.severity === 'critical' ? 'state-critical' : state.severity === 'warn' ? 'state-warn' : '')">
                  @if (state.severity !== 'normal') {
                    <nz-icon nzType="warning" nzTheme="fill"></nz-icon>
                  }
                  {{ state.awaitingLabel }}
                </div>
                <div class="state-time">
                  {{ state.referenceTime | date:'HH:mm' }}
                  @if (state.etaMinutesRemaining !== undefined) {
                    @if (state.etaMinutesRemaining >= 0) {
                      <span class="state-elapsed">({{ state.etaMinutesRemaining }} min remaining)</span>
                    } @else {
                      <span [class]="'state-elapsed ' + (state.severity === 'critical' ? 'state-critical' : 'state-warn')">({{ -state.etaMinutesRemaining }} min overdue)</span>
                    }
                  } @else {
                    <span class="state-elapsed">({{ state.minutesElapsed }} min ago)</span>
                  }
                </div>
              }
              <!-- @if (data.statusId === 7) {
                <button nz-button nzType="primary" nzSize="small" (click)="onClickDriverHasArrived(data)" style="margin-top: 6px;" nz-tooltip="Click to indicate tech has arrived on site">
                  <nz-icon nzType="check-circle" nzTheme="outline"></nz-icon> Tech Arrived
                </button>
              } -->
            </div>
          }
          @case ('eta') {
          @if (data.breakdownTechnicianDriverEta) {
          <div nz-col nzSpan="24" style="text-align: center;">
            <small><strong>{{ data.breakdownTechnicianDriverEta + 'Z' | date:'HH:mm' }}</strong></small>
            <br>
            @if (data.statusId < 8) {
              <small style="color: #8c8c8c;" >{{ gFuncs.formatMinutesToDuration(gFuncs.calculateMinutes(data.breakdownTechnicianDriverEta)) }}  </small><br>
              @if (etaChanges().has(data.incidentId)) {
                <nz-tag [nzColor]="etaChanges().get(data.incidentId)! > 0 ? 'orange' : 'green'" style="margin-top: 4px;">
                  {{ etaChanges().get(data.incidentId)! > 0 ? '+' : '' }}{{ etaChanges().get(data.incidentId) }} mins
                </nz-tag>
              }
              <!-- @if (data.breakdownTechnician && data.statusId == 7) {
                <button nz-button nzType="primary" nzSize="small" (click)="openTrackDriverModal(data)" nz-tooltip="Track Technician"><nz-icon nzType="environment"></nz-icon></button>
              }            -->
            }
          </div>
          } @else {
          <small style="color: #8c8c8c;">{{ data.statusId >= 7 ? 'N/A' : 'Not Assigned' }}</small>
          }
          }
          @case ('serviceProvider') {
          <div class="service-provider-cell">
            <div class="service-provider-details">
              <div style="font-weight: bold;">
                @let activeSp = getActiveServiceProviderLink(data);
                @if (activeSp) {
                  @if (isSpDirectlyLinked(activeSp.clientId)) {
                    @if (activeSp.whatsappGroupLink) {
                      <a class="service-provider-wa-link" (click)="openWaGroupOpener(data, activeSp.whatsappGroupLink)">
                        <small class="service-provider-name">{{ activeSp.clientName }}</small> <br />
                        @if (!data.incidentActions?.dtWAMessageCopiedSP) {
                          <nz-icon nzType="warning" nzTheme="fill" [ngStyle]="{ 'font-size': '16px', 'color': '#faad14' }" nz-tooltip nzTooltipTitle="Service provider has not been contacted yet"></nz-icon>
                        }
                        <nz-icon nzType="whats-app" nzTheme="outline" [ngStyle]="{ 'font-size': '18px', 'color': '#25D366' }"></nz-icon>
                        <small class="service-provider-group-name">{{ activeSp.whatsappGroupName ? activeSp.whatsappGroupName : '' }}</small>
                      </a>
                    } @else if (activeSp.clientName !== '') {
                      <small class="service-provider-name">{{ activeSp.clientName }} </small><br />
                      <a (click)="openSPWAGroupModal(activeSp.clientId, data.incidentId)" >
                        @if (!data.incidentActions?.dtWAMessageCopiedSP) {
                          <nz-icon nzType="warning" nzTheme="fill" [ngStyle]="{ 'font-size': '16px', 'color': '#faad14' }" nz-tooltip nzTooltipTitle="Service provider has not been contacted yet"></nz-icon>
                        }
                        <nz-icon nzType="whats-app" nzTheme="outline" [ngStyle]="{ 'font-size': '18px', 'color': '#8c8c8c' }" nz-tooltip="Click to add WhatsApp Group"></nz-icon>
                      </a>
                    }
                  } @else {
                    <small class="service-provider-name">{{ getViaServiceProviderDisplayName(activeSp) }}</small>
                  }
                }
              </div>
              <div><small>{{ data.serviceProviderDriverName }}</small></div>
            </div>
            <a (click)="openSPActionLink(data.incidentId)" style="cursor: pointer; margin-left: 6px; flex-shrink: 0;" nz-tooltip nzTooltipTitle="Open service provider action page">
              <nz-icon nzType="link" nzTheme="outline" [ngStyle]="{ 'font-size': '16px', 'color': '#1890ff' }"></nz-icon>
            </a>
          </div>
          }
          @case ('callCentre') {
          <small>{{ data.callcentreName }}</small>
          }

          <!-- @case ('location') {
          <span nz-tooltip [nzTooltipTitle]="data.location.description">
            <small>{{ data.location.descriptionShort }}</small>
          </span>
          } -->
          <!-- @case ('receivedInvoice') {
          <button nz-button nzType="primary" nz-tooltip="Navigate to Invoice" (click)="viewDoc(data, 5)"><nz-icon
              nzType="inbox"></nz-icon></button>
          }
          @case ('sentInvoice') {
          <button nz-button nzType="primary" nz-tooltip="Navigate to Invoice" (click)="viewDoc(data, 4)"><nz-icon
              nzType="send"></nz-icon></button>
          }
          @case ('latestQuote') {
          <button nz-button nzType="primary" nz-tooltip="Navigate to Quote" (click)="viewDoc(data, 2)"><nz-icon
              nzType="file-text" nzTheme="outline"></nz-icon></button>
          } -->
          @case('timeElapsed'){
            <div nz-col nzAlign="middle" nzJustify="center">
                <small>{{ gFuncs.formatMinutesToDuration(calculateTimeElapsed(data.dtLogged)) }}</small> <br>
              <button nz-button nzType="primary" nzSize="small" (click)="openCompleteWithoutWorkReportConfirmModal(data.incidentId)" nz-tooltip="Complete Breakdown With No Work Report">Complete</button>
            </div>

          } 
          <!-- @case('pow') {
            @if (data.statusId >= 5 && data.statusId <= 15) {
              <button nz-button nzType="primary" nz-tooltip="Upload Proof of Work" (click)="onClickUploadPoW(data.incidentId)"><nz-icon
                  nzType="upload"></nz-icon></button>
            }
            @if (data.statusId > 10) {
              <small style="color: #8c8c8c; margin-left: 8px;"><button nz-button nzType="primary" nz-tooltip="Download Proof of Work Report" (click)="onClickProofOfWork(data.incidentId)" [nzLoading]="isLoadingProofOfWork"><nz-icon
                  nzType="download"></nz-icon></button></small>
            }
            @else {
              &nbsp;
            }
          }
          @case('spinvoice') {
            @if (data.statusId >= 12 && hasSPInvoice(data)) {
              <button nz-button nzType="primary" nz-tooltip="Download Service Provider Invoice" (click)="onClickViewSPInvoice(data.incidentId)" nzSize="small" >
                <nz-icon nzType="eye"></nz-icon> View</button>
            } @else if (data.statusId >= 11 && !hasSPInvoice(data)) {
              <button nz-button nzType="primary" nz-tooltip="Upload Service Provider Invoice" (click)="onClickUploadSPInvoice(data.incidentId)" nzSize="small" >
                <nz-icon nzType="upload"></nz-icon> Upload</button>
            }
            @else {
              &nbsp;
            }
          }
          @case('updatepo') {
            @if (data.statusId === 12) {
              <button nz-button nzType="primary" nz-tooltip="Go to Service Provider Quote" (click)="onClickGoToServiceProviderQuote(data.incidentId)" nzSize="small" >
                <nz-icon nzType="shopping-cart"></nz-icon> Update</button>
            }
            @else if (data.statusId > 12) {
              <b><small>R{{getServiceProviderQuoteTotal(data.incidentId) }} ex vat</small></b>
            }
            @else {
              &nbsp;
            }
          }
          @case('reinvoice') {
            @if (data.statusId === 15) {
              <button nz-button nzType="primary" nz-tooltip="Re-invoice Customer" (click)="onClickReInvoiceCustomer(data.incidentId)" nzSize="small" >
                <nz-icon nzType="redo"></nz-icon> Re-invoice</button>
            }
            @else if (data.statusId > 15) {
              <b><small>R{{getFleetQuoteTotal(data.incidentId) }} ex vat</small></b><br />
               <button nz-button nzType="primary" nz-tooltip="View Fleet Invoice" (click)="onClickReInvoiceCustomer(data.incidentId)" nzSize="small" >
                <nz-icon nzType="eye"></nz-icon> View</button>
            }
            @else {
              &nbsp;
            }
          }
          @case ('invoice') {
            @if (data.statusId >= 16 && hasFleetInvoice(data)) {
              <button nz-button nzType="primary" nz-tooltip="Download Fleet Invoice" (click)="onClickViewFleetInvoice(data.incidentId)" nzSize="small" >
                <nz-icon nzType="eye"></nz-icon> View</button>
            } @else if (data.statusId >= 16 && !hasFleetInvoice(data)) {
              <button nz-button nzType="primary" nz-tooltip="Upload Fleet Invoice" (click)="onClickUploadFleetInvoice(data.incidentId)" nzSize="small" >
                <nz-icon nzType="upload"></nz-icon> Upload</button> -->
            <!-- } -->
            <!-- @else {
              &nbsp;
            } -->
          <!-- } -->
          @case ('actions') {
          <nz-space nzSize="small" nzDirection="vertical">
            <button *nzSpaceItem nz-button nzType="primary" nzSize="small" (click)="onClickViewIncident(data)">
              <span nz-icon nzType="eye"></span>
              View
            </button>
            <!-- <button *nzSpaceItem nz-button nzSize="small" (click)="onClickNavigate(data)">
                        <span nz-icon nzType="compass"></span>
                        Navigate
                      </button>
                      <button *nzSpaceItem nz-button nzSize="small" (click)="onClickProofOfWork(data.incidentId)">
                        <span nz-icon nzType="file-pdf"></span>
                        PoW
                      </button> -->
            @if (data.statusId >= 16 && authService.isClientCallCentre) {
              <button *nzSpaceItem nz-button nzType="primary" nzSize="small" (click)="onClickCompleteIncident(data.incidentId)">
                <nz-icon nzType="check-circle" nzTheme="outline" />
                Complete
              </button>
            }
          </nz-space>
          }
        }
        </td>
      }
    </tr>
      }
  }
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isUploadModalVisible" nzTitle="Upload File" (nzOnCancel)="isUploadModalVisible = false"
  (nzOnOk)="isUploadModalVisible = false">
  <ng-container *nzModalContent>
    <app-file-uploader [incidentId]="selectedIncidentId()" [documentClassification]="selectedUploadDocumentClassificationId()"
      (uploadedDocuments)="onUploadComplete($event)"></app-file-uploader>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isTrackTechModalVisible" nzTitle="Track Driver" (nzOnCancel)="isTrackTechModalVisible = false"
  (nzOnOk)="isTrackTechModalVisible = false" [nzWidth]="850" >
  <ng-container *nzModalContent>
    <app-map-track-sp-tech [incident]="trackTechForIncident()"></app-map-track-sp-tech>
  </ng-container>
<app-incident-close-modal 
    [(visible)]="isCloseIncidentModalVisible" 
    [incidentId]="selectedIncidentIdToClose"
    (incidentClosed)="onIncidentClosed()">
</app-incident-close-modal>

</nz-modal>

<nz-modal [nzVisible]="isSPWAGroupModalOpen()" nzTitle="Add Service Provider WhatsApp Group" (nzOnCancel)="isSPWAGroupModalOpen.set(false)"
  (nzOnOk)="saveSPWAGroupLink()" >
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="waGroupForm">
       <nz-form-item>
          <nz-form-label>WhatsApp Group Link</nz-form-label>
          <nz-form-control>
              <input nz-input formControlName="whatsappGroupLink" placeholder="Enter service provider WhatsApp group link" (blur)="onGroupLinkBlur()"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label>WhatsApp Group Name</nz-form-label>
          <nz-form-control>
            <ng-template #loadingSuffix>
              @if (isLoadingGroupName()) {
                <nz-icon nzType="loading"></nz-icon>
              }
            </ng-template>
            <nz-input-group [nzSuffix]="loadingSuffix">
              <input nz-input formControlName="whatsappGroupName" placeholder="Group name (auto-filled from link)"/>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
    </form>
  </ng-container>
</nz-modal>


<nz-modal
    [(nzVisible)]="isWaGroupOpenerModalVisible"
    nzTitle="WhatsApp Group Messages"
    (nzOnCancel)="isWaGroupOpenerModalVisible = false"
    [nzFooter]="null"
    [nzWidth]="650">
  <ng-container *nzModalContent>
    @if (waGroupOpenerIncident()) {
      <app-wa-group-opener
        [incident]="waGroupOpenerIncident()!"
        [whatsappLink]="waGroupOpenerLink"
        [isFleet]="waGroupOpenerIsFleet">
      </app-wa-group-opener>
    }
  </ng-container>
</nz-modal>

<nz-modal
    [(nzVisible)]="isCompleteWithoutWorkReportConfirmModalVisible"
    nzTitle="Complete Breakdown Without Work Report"
    (nzOnCancel)="isCompleteWithoutWorkReportConfirmModalVisible = false"
    (nzOnOk)="onClickCompleteWithoutWorkReport()"
    nzOkText="Yes, Complete"
    nzCancelText="Cancel"
    nzWidth="450px">
    <ng-container *nzModalContent>
        <nz-alert nzType="warning" nzShowIcon nzMessage="No Work Report Selected" style="margin-bottom: 16px;"
            nzDescription="You are about to complete this breakdown without attaching a work report. Are you sure you want to proceed?">
        </nz-alert>
    </ng-container>
</nz-modal>
